'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _div;
import { Loader } from '@crehana/compass.ui/loader';
import { useIsClient } from '@crehana/react-hooks';
import { useSearchParams } from 'next/navigation';
import { CommonLayouts } from "./_components/CommonLayouts";
import { jsx as _jsx } from "react/jsx-runtime";
export var AppRouterRoot = function AppRouterRoot(props) {
  var searchParams = useSearchParams();
  var isClient = useIsClient();

  // in talent pages, all urls have this query param to identify the current organization
  var centralizedOrganizationSlug = searchParams.get('centralizedOrganizationSlug');
  if (!isClient) {
    return _div || (_div = /*#__PURE__*/_jsx("div", {
      className: "tw-w-screen tw-h-screen tw-flex tw-items-center tw-justify-center",
      children: /*#__PURE__*/_jsx(Loader, {})
    }));
  }
  return /*#__PURE__*/_jsx(CommonLayouts, _objectSpread(_objectSpread({}, props), {}, {
    organizationSlug: centralizedOrganizationSlug || '',
    children: props.children
  }));
};